import { v4 as uuidV4 } from 'uuid';

import { IObjectWithId } from 'interfaces/common';

export const getTotalItems = (items: Record<string, string>[]): IObjectWithId => {
  const totalItems: IObjectWithId = { id: uuidV4() };

  items.forEach((item) => {
    Object.keys(item).forEach((key) => {
      if (key === 'id') return; // Skip 'id' since it's unique and should not be summed.

      const itemValue = item[key];
      const value = Number(itemValue);

      if (!isNaN(value)) {
        // Use a more explicit casting and checking method to satisfy TypeScript's type safety.
        totalItems[key] = ((totalItems[key] as number) || 0) + value;
      }
    });
  });

  return totalItems;
};
